import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const tabFields = {
    info: {
        tabName: "Información principal",
        fieldNames: {
            name: "Nombre",
            lastname1: "Apellido paterno",
            lastname2: "Apellido materno",
            curp: "CURP / DNI / Número de ciudadanía",
            birthday: "Fecha de nacimiento",
            nacionality: "Nacionalidad",
            cityBirth: "Ciudad de nacimiento",
            gender: "Género",
        },
    },
};

export const PendingInfo = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { pendingInfo } = useSelector((state) => state.auth);

    useEffect(() => {
        const fields = pendingInfo?.fields ?? {};

        if (pendingInfo && Object.keys(fields).length > 0) {
            const pathName = location.pathname;
            const profilePath = "/app/profile";

            if (pathName !== profilePath) {
                const { tab } = pendingInfo;
                const tabData = tabFields[tab];
                const tabName = tabData?.tabName ?? "Información";

                const fieldNamesHtml = Object.keys(fields)
                    .map((key) => tabData?.fieldNames?.[key] || key)
                    .map((name) => `<li>${name}</li>`)
                    .join("");

                navigate("/app/profile");

                Swal.fire({
                    title: "<strong>Información pendiente por completar</strong>",
                    html: `
                        <div style="text-align: left">
                            <p>
                                Estimado estudiante, detectamos que tienes información pendiente
                                en la sección <strong>${tabName}</strong> de tu perfil.
                            </p>
                            <p>
                                Para continuar y acceder a las demás funciones del sistema,
                                es necesario completar los siguientes campos:
                            </p>
                            <ul>${fieldNamesHtml}</ul>
                            <p>
                                <strong>Importante:</strong> Mientras no se complete esta información,
                                el acceso al resto de los apartados permanecerá restringido.
                            </p>
                        </div>
                    `,
                    icon: "warning",
                    confirmButtonText: "Entendido",
                    backdrop: true,
                });
            }
        }
    }, [location, pendingInfo, navigate]);

    return null;
};
